import { EyeOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const LinkBtn = ({
  icon,
  displayText = true,
  text = null,
  ...restProps
}) => {
  return (
    <Button
      variant="link"
      color="default"
      icon={!icon ? <EyeOutlined /> : null}
      {...restProps}
    >
      {displayText && (text == null ? "Ver todos" : text)}
    </Button>
  );
};
